/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCustomListMonitoringField
 */
export interface InternalApiCustomListMonitoringField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListMonitoringField
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListMonitoringField
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListMonitoringField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListMonitoringField
     */
    code?: string;
    /**
     * Ids of schema fields to be included with usable field
     * @type {Array<string>}
     * @memberof InternalApiCustomListMonitoringField
     */
    additionalSchemaFields?: Array<string>;
}

/**
 * Check if a given object implements the InternalApiCustomListMonitoringField interface.
 */
export function instanceOfInternalApiCustomListMonitoringField(value: object): value is InternalApiCustomListMonitoringField {
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiCustomListMonitoringFieldFromJSON(json: any): InternalApiCustomListMonitoringField {
    return InternalApiCustomListMonitoringFieldFromJSONTyped(json, false);
}

export function InternalApiCustomListMonitoringFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListMonitoringField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'path': json['path'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'additionalSchemaFields': json['additionalSchemaFields'] == null ? undefined : json['additionalSchemaFields'],
    };
}

export function InternalApiCustomListMonitoringFieldToJSON(json: any): InternalApiCustomListMonitoringField {
    return InternalApiCustomListMonitoringFieldToJSONTyped(json, false);
}

export function InternalApiCustomListMonitoringFieldToJSONTyped(value?: InternalApiCustomListMonitoringField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'path': value['path'],
        'name': value['name'],
        'code': value['code'],
        'additionalSchemaFields': value['additionalSchemaFields'],
    };
}

